const PLATFORMS = {
  MOBILE: "MOBILE",
  DESKTOP: "DESKTOP",
};

export default PLATFORMS;
